import { render, staticRenderFns } from "./CancellationApproved.vue?vue&type=template&id=86503ab0&"
import script from "./CancellationApproved.vue?vue&type=script&lang=js&"
export * from "./CancellationApproved.vue?vue&type=script&lang=js&"
import style0 from "./CancellationApproved.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CancellationApproved.vue"
export default component.exports